import { Link, Stack, Typography } from '@mui/material';
import { WwwIcon } from 'framework/ui/mui-builder';
import type { ApplicationDetails } from '../../shared/types';
import moment from 'moment';
import { DATE_FORMAT } from 'framework/utils';

type ApplicationSummarySectionProps = {
  application: ApplicationDetails;
};

const ApplicationSummarySection = ({ application }: ApplicationSummarySectionProps) => (
  <Stack gap={1.25} sx={{ py: 1.5 }}>
    <Typography variant="body2" color="textSecondary">
      Created on {moment(application.createdAt).format(DATE_FORMAT.SIMPLE)}
    </Typography>
    <Stack direction="row" alignItems="center" gap={1.25}>
      <WwwIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
      <Link href="#" variant="body1" underline="hover">
        {application.jobPostingName}
      </Link>
    </Stack>
  </Stack>
);

export default ApplicationSummarySection;
